import { Component, OnInit } from '@angular/core';
import Chart from 'chart.js/auto';
import { ConsumedSummaryService } from 'src/app/home/services/consumed-summary.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-consumption-summary', 
  templateUrl: './consumption-summary.component.html',
  styleUrls: ['./consumption-summary.component.scss']
})
export class ConsumptionSummaryComponent implements OnInit {

  public chartData: any;  
  public stockId: string = ""; 

  constructor(private route: ActivatedRoute, private consumedSummaryService: ConsumedSummaryService) { }

  ngOnInit(): void { 
    this.route.queryParams.subscribe(params => {
      const storeIdFromParams = params['id'];
      if (storeIdFromParams) { 
        this.stockId = storeIdFromParams; 
        this.createBarChart(this.stockId);
      } else {
        console.error('No stock ID provided in query parameters');
      }
    });
  } 
 
  createBarChart(storeId: string): void {
    this.consumedSummaryService.getChartData(storeId).subscribe({
      next: (res) => {
        this.chartData = res.data;
        this.generateChart();
      },
      error: (e) => console.error(e),
      complete: () => console.info('complete') 
    });
  } 
   
  generateChart(): void {
      const ctx = document.getElementById('barChart') as HTMLCanvasElement;
      
      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.chartData.labels,
          datasets: this.chartData.datasets.map(dataset => ({
            label: dataset.label,
            data: dataset.data,
            backgroundColor: dataset.backgroundColor || '#2386DB',
            borderWidth: dataset.borderWidth || 1
          }))   
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: false,
              position: 'top'
            },
            title: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  let label = context.dataset.label || '';
                  if (label) {
                    label += ': ';
                  }
                  if (context.parsed.y !== null) {
                    label += context.parsed.y;
                  }
                  // return 'Consumed on ' + context.label + ': ' + label;
                }
              }
            }
          },
          scales: {
            x: {
              grid: {
                display: false 
              }
            },
            y: {
              grid: {
                display: true 
              },
              title: {
                display: true,
                text: 'Quantity', 
                align: 'center', 
                color: 'black',
                font: {
                  size: 12 
                }
              },
              ticks: {
                stepSize: 1, // Define the step size for the ticks
                callback: function(value) {
                  return value; // Ensure the value is displayed as an integer
                } 
              },
              min: 0, // Set the minimum value
              max: 4
            }
          }
        }
      });
  } 
}
